// extracted by mini-css-extract-plugin
export default {"table":"components-hotel-pricing-assistant-table-table-pricing-manager-module__table"};